import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { getTrustedInput } from "./getTrustedInput";
import { startUntrustedHashTransactionInput } from "./startUntrustedHashTransactionInput";
import { getTrustedInputBIP143 } from "./getTrustedInputBIP143";
import { signTransaction } from "./signTransaction";
import { hashOutputFull } from "./finalizeInput";
import { DEFAULT_LOCKTIME, DEFAULT_VERSION, DEFAULT_SEQUENCE, SIGHASH_ALL } from "./constants";
var defaultArg = {
  lockTime: DEFAULT_LOCKTIME,
  sigHashType: SIGHASH_ALL,
  segwit: false,
  transactionVersion: DEFAULT_VERSION
};
/**
 *
 */

export function signP2SHTransaction(_x, _x2) {
  return _signP2SHTransaction.apply(this, arguments);
}

function _signP2SHTransaction() {
  _signP2SHTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(transport, arg) {
    var _defaultArg$arg, inputs, associatedKeysets, outputScriptHex, lockTime, sigHashType, segwit, transactionVersion, nullScript, nullPrevout, defaultVersion, trustedInputs, regularOutputs, signatures, firstRun, resuming, targetTransaction, getTrustedInputCall, outputScript, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _input, trustedInput, _sequence, outputs, index, i, sequence, _i, input, script, pseudoTX, pseudoTrustedInputs, signature;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _defaultArg$arg = _objectSpread({}, defaultArg, arg), inputs = _defaultArg$arg.inputs, associatedKeysets = _defaultArg$arg.associatedKeysets, outputScriptHex = _defaultArg$arg.outputScriptHex, lockTime = _defaultArg$arg.lockTime, sigHashType = _defaultArg$arg.sigHashType, segwit = _defaultArg$arg.segwit, transactionVersion = _defaultArg$arg.transactionVersion; // Inputs are provided as arrays of [transaction, output_index, redeem script, optional sequence]
            // associatedKeysets are provided as arrays of [path]

            nullScript = Buffer.alloc(0);
            nullPrevout = Buffer.alloc(0);
            defaultVersion = Buffer.alloc(4);
            defaultVersion.writeUInt32LE(transactionVersion, 0);
            trustedInputs = [];
            regularOutputs = [];
            signatures = [];
            firstRun = true;
            resuming = false;
            targetTransaction = {
              inputs: [],
              version: defaultVersion
            };
            getTrustedInputCall = segwit ? getTrustedInputBIP143 : getTrustedInput;
            outputScript = Buffer.from(outputScriptHex, "hex");
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 16;
            _iterator = inputs[Symbol.iterator]();

          case 18:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 33;
              break;
            }

            _input = _step.value;

            if (resuming) {
              _context.next = 27;
              break;
            }

            _context.next = 23;
            return getTrustedInputCall(transport, _input[1], _input[0]);

          case 23:
            trustedInput = _context.sent;
            _sequence = Buffer.alloc(4);

            _sequence.writeUInt32LE(_input.length >= 4 && typeof _input[3] === "number" ? _input[3] : DEFAULT_SEQUENCE, 0);

            trustedInputs.push({
              trustedInput: false,
              value: segwit ? Buffer.from(trustedInput, "hex") : Buffer.from(trustedInput, "hex").slice(4, 4 + 0x24),
              sequence: _sequence
            });

          case 27:
            outputs = _input[0].outputs;
            index = _input[1];

            if (outputs && index <= outputs.length - 1) {
              regularOutputs.push(outputs[index]);
            }

          case 30:
            _iteratorNormalCompletion = true;
            _context.next = 18;
            break;

          case 33:
            _context.next = 39;
            break;

          case 35:
            _context.prev = 35;
            _context.t0 = _context["catch"](16);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 39:
            _context.prev = 39;
            _context.prev = 40;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 42:
            _context.prev = 42;

            if (!_didIteratorError) {
              _context.next = 45;
              break;
            }

            throw _iteratorError;

          case 45:
            return _context.finish(42);

          case 46:
            return _context.finish(39);

          case 47:
            // Pre-build the target transaction
            for (i = 0; i < inputs.length; i++) {
              sequence = Buffer.alloc(4);
              sequence.writeUInt32LE(inputs[i].length >= 4 && typeof inputs[i][3] === "number" ? inputs[i][3] : DEFAULT_SEQUENCE, 0);
              targetTransaction.inputs.push({
                script: nullScript,
                prevout: nullPrevout,
                sequence: sequence
              });
            }

            if (!segwit) {
              _context.next = 53;
              break;
            }

            _context.next = 51;
            return startUntrustedHashTransactionInput(transport, true, targetTransaction, trustedInputs, true);

          case 51:
            _context.next = 53;
            return hashOutputFull(transport, outputScript);

          case 53:
            _i = 0;

          case 54:
            if (!(_i < inputs.length)) {
              _context.next = 74;
              break;
            }

            input = inputs[_i];
            script = inputs[_i].length >= 3 && typeof input[2] === "string" ? Buffer.from(input[2], "hex") : regularOutputs[_i].script;
            pseudoTX = Object.assign({}, targetTransaction);
            pseudoTrustedInputs = segwit ? [trustedInputs[_i]] : trustedInputs;

            if (segwit) {
              pseudoTX.inputs = [_objectSpread({}, pseudoTX.inputs[_i], {
                script: script
              })];
            } else {
              pseudoTX.inputs[_i].script = script;
            }

            _context.next = 62;
            return startUntrustedHashTransactionInput(transport, !segwit && firstRun, pseudoTX, pseudoTrustedInputs, segwit);

          case 62:
            if (segwit) {
              _context.next = 65;
              break;
            }

            _context.next = 65;
            return hashOutputFull(transport, outputScript);

          case 65:
            _context.next = 67;
            return signTransaction(transport, associatedKeysets[_i], lockTime, sigHashType);

          case 67:
            signature = _context.sent;
            signatures.push(segwit ? signature.toString("hex") : signature.slice(0, signature.length - 1).toString("hex"));
            targetTransaction.inputs[_i].script = nullScript;

            if (firstRun) {
              firstRun = false;
            }

          case 71:
            _i++;
            _context.next = 54;
            break;

          case 74:
            return _context.abrupt("return", signatures);

          case 75:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[16, 35, 39, 47], [40,, 42, 46]]);
  }));
  return _signP2SHTransaction.apply(this, arguments);
}